var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-textarea',{class:{
    required: _vm.required && !_vm.internalValue,
    'v-textarea-custom-no-soft-wrap': this.noSoftWrap
  },attrs:{"outlined":"","background-color":"grey lighten-4","filled":"","label":_vm.label,"dense":"","hide-details":"","readonly":_vm.readonly,"disabled":_vm.readonly,"rules":_vm.rules,"rows":_vm.rows,"no-resize":_vm.noResize},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }